const formatAmount = (amount) => {
  if (amount == 0) {
    return 0;
  }
  if (amount >= 1e9) {
      return (amount / 1e9).toFixed(2) + 'B';
  } else if (amount >= 1e6) {
      return (amount / 1e6).toFixed(2) + 'M';
  } else if (amount >= 1e3) {
      return (amount / 1e3).toFixed(2) + 'K';
  } else {
      return amount.toFixed(2);
  }
}

export default formatAmount;
